import { Component, OnInit } from '@angular/core';
import {ServicesComponent} from "../services.component";
import {WebDesignComponent} from "./web-design.component";

@Component({
  selector: 'app-mobile',
  template: `
    <div class="service-detail" id="top">
        <h2><span class="bottomBorder" style="padding-bottom: 4%;">MOBILE</span> APPS</h2>
        <div class="scale-less-margin"></div>
        <article>Smartphones and tablets are actively gaining popularity among internet users.
         Mobile apps in turn are becoming one of the most effective tools to attract new clients and meet the increasing demands of the existing ones.
          </article>
        <article style="margin-bottom: 6%"> Today, if you wish to grow your business, increase your profit, and expand your audience,
         then attracting smartphone users should be one of your main priorities.</article>
        <div class="details-container first">
          <div class="checked"></div>
          <h5>iOS Development</h5></div>
        <p style="display: block" class="slider">There are many variations of passages available, randomised words which don't look even slightly believable. If you are going to Lorem Ipsum. </p>
        <div class="details-container second">
          <div class="checkMark"></div>
          <h5>Android Development</h5></div>
        <p class="slider">There are many variations of passages available, randomised words which don't look even slightly believable. If you are going to Lorem Ipsum. </p>
        <div class="details-container third">
          <div class="checkMark"></div>
          <h5>Web Application Development</h5></div>
        <p class="slider">There are many variations of passages available, randomised words which don't look even slightly believable. If you are going to Lorem Ipsum. </p>
      </div>
  `,
  styleUrls: ['./mobile.component.css']
})
export class MobileComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    this.slider();
    WebDesignComponent.firstStart(this, 4);
  }

  slider () {
    $('.first').click(function () {
      WebDesignComponent.initializeSlide(this);
    });

    $('.second').click(function () {
      WebDesignComponent.initializeSlide(this);
    });

    $('.third').click(function () {
      WebDesignComponent.initializeSlide(this);
    });

    $('.forth').click(function () {
      WebDesignComponent.initializeSlide(this);
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/services/descriptionComponents/mobile.component.ts